var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSalesforce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 1.963a4.58 4.58 0 013.297-1.4 4.61 4.61 0 014.01 2.352 5.595 5.595 0 012.268-.477A5.6 5.6 0 0126 8.031a5.599 5.599 0 01-6.71 5.484 4.104 4.104 0 01-3.576 2.076 4.115 4.115 0 01-1.792-.408A4.677 4.677 0 019.619 18a4.675 4.675 0 01-4.388-3.027A4.338 4.338 0 012.17 6.971a4.919 4.919 0 01-.416-1.983C1.754 2.233 4.016 0 6.804 0c1.638 0 3.093.77 4.016 1.963",
    fill: "#00A1E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default ForwardRef;